import {h, Fragment} from "preact"
import { AutocompleteElement, SerpElement, useCurrencyFormatting } from "@nosto/preact";
import { productImagePlaceholder } from "../helpers";
import Swatches from "./elements/swatches";
import { useEffect, useState } from "preact/hooks";

export default function ProductSwatch({ product }) {
    const { format } = useCurrencyFormatting();
    const [selectedColor, setSelectedColor] = useState(null);
    const [currentImage, setCurrentImage] = useState(product?.skus[0].imageUrl ?? product?.imageUrl ?? productImagePlaceholder);
    const [fade, setFade] = useState(false);
console.log(currentImage,'kkk')
    const tags = [
        product.onSale
            ? {
                  label: "Sale",
                  class: "ns-badge ns-badge-green-outline ns-d-inline-block ns-text-align-center"
              }
            : undefined
    ].filter(Boolean);

    const bannerField = product?.customFields?.find(field => field.key === 'product-custom_banner');
    const badgeField = product?.customFields?.find(field => field.key === 'product-custom_badge');

    const uniqueColors = [
        ...new Set(
            product.skus
                ?.flatMap(sku => sku.customFields?.filter(field => field.key === "color").map(field => field.value) || [])
        ),
    ];

    const selectedColorSku = selectedColor
        ? product.skus.find(sku =>
              sku.customFields?.find(field =>
                  field.key === "color" &&
                  field.value.trim().toLowerCase() === selectedColor.trim().toLowerCase()
              )
          )
        : null;

    useEffect(() => {
        const newImage = selectedColorSku?.imageUrl ?? product?.skus[0].imageUrl ?? product?.imageUrl;
        if (newImage !== currentImage) {
            setFade(true); // trigger fade out
            const timeout = setTimeout(() => {
                setCurrentImage(newImage); // switch image
                setFade(false); // fade in
            }, 200); // duration of fade out
            return () => clearTimeout(timeout);
        }
    }, [selectedColor]);

console.log(currentImage,'imagess')
    return (
        <div
            class="card-product-pxg isolate flex flex-col content-between"
        >
            <div class="product-card relative flex flex-auto flex-col">
            <AutocompleteElement key={product.productId} hit={product}>
                <div class="group relative block aspect-square overflow-hidden">
                    {badgeField && (
                        <div class="absolute left-2 top-2 z-10">
                            <p class="badge">{badgeField.value}</p>
                        </div>
                    )}

                    <a href={product.url}>
                    <picture>
                        <img
                            className={`w-full h-full object-cover object-center transition-opacity duration-500 ease-in-out ${
                                fade ? "opacity-0" : "opacity-100"
                            }`}
                            src={currentImage.trim() || product.imageUrl}
                            alt={product.name}
                            width="600"
                            height="400"
                        />
                    </picture>
                    </a>
                </div>

                <div class="mt-4 flex flex-col" data-nosto-element="product">
                    <div class="flex-auto">
                        <div class="flex justify-between gap-1">
                            <h2 class="font-bold leading-tight">
                                <a href={product.url} class="block text-shadow-black">
                                    {product.name}
                                </a>
                            </h2>
                        </div>

                        {tags.length > 0 && (
                            <div class="ns-tags ns-absolute ns-mb-1">
                                {tags.map(v => (
                                    <span key={v.label} class={v.class}>
                                        {v.label}
                                    </span>
                                ))}
                            </div>
                        )}

                        {bannerField && <div class="text-xxs opacity-70">{bannerField.value}</div>}

                        <a href={product.url} class="mt-1 block text-xxs textshadow-black">
                            <div className={`price ${product.listPrice > product.price ? "price--on-sale" : ""}`}>
                                <div class="price__container">
                                    <div class="price__regular">
                                        <span class="visually-hidden visually-hidden--inline">Regular price</span>
                                        <span class="price-item price-item--regular">{format(product.price)}</span>
                                    </div>
                                    <div class="price__sale">
                                        <span class="visually-hidden visually-hidden--inline">Regular price</span>
                                        <span>
                                            <s class="price-item price-item--regular">{format(product.listPrice)}</s>
                                        </span>
                                        <span class="visually-hidden visually-hidden--inline">Sale price</span>
                                        <span class="price-item price-item--sale price-item--last">
                                            {format(product.price)}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>

                </div>
            </AutocompleteElement>
            <Swatches product={product} onColorSelect={setSelectedColor} />
            </div>
        </div>
    );
}
